<template>
    <div class="main_body">
        <!-- <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" /> -->
        <div class="container-fluid">
        </div>
        <div style="margin-left:20px;" class="pb-4">
            <h2>Play Counts</h2>
        </div>
        <div class="align-items-center justify-content-center text-center">
            <div class="btn-group" role="group" aria-button="Basic radio toggle button group">
                <!-- <button type="button" @click="playCountTot" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">AudioBook Play</button> -->
                <button type="button" @click="playCountTot" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">Play Count
                    Total</button>
                <button type="button" @click="playEpisodeTotal" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">Play Count
                    Episode Total</button>
                <!-- <button type="button" @click="playEpisode" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">Play
                    Episode</button> -->
                <button type="button" @click="totalCountWeb" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">Play Count From Web</button>

                <button type="button" @click="totalFromAndroid" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">Play Count From Android</button>
                <button type="button" @click="totalFromWebEpi" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">Total Count from
                    Web Episode</button>
                <button type="button" @click="totalFromAndroidEpi" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">Total Count from
                    Android Episode</button>
                <button type="button" @click="totalAudLogs" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">
                    Audiobook Play Logs</button>
                <button type="button" @click="totalEpiLogs" class="btn btn-primary" aria-expanded="false"
                    aria-controls="collapseExample">Episodes Play Logs</button>
            </div>
            <div v-if="playCountTotal === true" class="row align-items-center justify-content-center text-center my-5">
                <PlayCountTotal></PlayCountTotal>
            </div>
            <div v-if="playEpisodeTot === true" class="row align-items-center justify-content-center text-center my-5">
                <PlayCountEpisodeTotal></PlayCountEpisodeTotal>
            </div>
            <!-- <div v-if="playEpi === true" class="row align-items-center justify-content-center text-center my-5">
                <PlayEpisode></PlayEpisode>
            </div> -->
            <div v-if="totCountWeb === true"
                class="row align-items-center justify-content-center text-center my-5 show">
                <PlayCountFromWeb></PlayCountFromWeb>
            </div>
            <div v-if="totCountAndroid === true" class="row align-items-center justify-content-center text-center my-5">
                <PlayCountFromAndroid></PlayCountFromAndroid>
            </div>
            <div v-if="playCountWebEpi === true" class="row align-items-center justify-content-center text-center my-5">
                <playCountFromWebEpisode></playCountFromWebEpisode>
            </div>
            <div v-if="playCountAndEpi === true" class="row align-items-center justify-content-center text-center my-5">
                <PlayCountFromAndroidEpisode></PlayCountFromAndroidEpisode>
            </div>
            <div v-if="audPlayLogs === true" class="row align-items-center justify-content-center text-center my-5">
                <AudioBookPlayLogs></AudioBookPlayLogs>
            </div>
            <div v-if="epiPlayLogs === true" class="row align-items-center justify-content-center text-center my-5">
                <EpisodesPlayLogs></EpisodesPlayLogs>
            </div>
            <div>
                <div v-if="loadFlag === true"
                    class="row align-items-center justify-content-center text-center my-5 show">
                    <PlayCountTotal></PlayCountTotal>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PlayCountTotal from '../playCounts/PlayCountTotal'
import PlayCountEpisodeTotal from './PlayCountEpisodeTotal'
// import PlayEpisode from './PlayEpisode'
import PlayCountFromWeb from './PlayCountFromWeb'
import PlayCountFromAndroid from './PlayCountFromAndroid'
import PlayCountFromWebEpisode from './PlayCountFromWebEpisode'
import PlayCountFromAndroidEpisode from './PlayCountFromAndroidEpisode'
import AudioBookPlayLogs from './AudioBookPlayLogs'
import EpisodesPlayLogs from './EpisodesPlayLogs'
export default {
    data() {
        return {
            playCountTotal: false,
            playEpi: false,
            playEpisodeTot: false,
            totCountWeb: false,
            totCountAndroid: false,
            playCountWebEpi: false,
            playCountAndEpi: false,
            audioBookPlay: false,
            audPlayLogs: false,
            epiPlayLogs: false,
            loadFlag: true
        }
    },
    components: {
        PlayCountTotal,
        PlayCountEpisodeTotal,
        // PlayEpisode,
        PlayCountFromWeb,
        PlayCountFromAndroid,
        PlayCountFromWebEpisode,
        PlayCountFromAndroidEpisode,
        AudioBookPlayLogs,
        EpisodesPlayLogs
    },
    // mounted() {
    //     this.playCountAll = true
    //     this.playCountTotal()
    // },
    methods: {
        audioBook() {
            this.audioBookPlay = !this.audioBookPlay
            this.playCountTotal = false
            this.playEpisodeTot = false
            this.playEpi = false
            this.totCountWeb = false
            this.totCountAndroid = false
            this.playCountWebEpi = false
            this.playCountAndEpi = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.audPlayLogs = false
            this.epiPlayLogs = false
        },
        playCountTot() {
            this.playCountTotal = !this.playCountTotal
            this.playEpisodeTot = false
            this.playEpi = false
            this.totCountWeb = false
            this.totCountAndroid = false
            this.playCountWebEpi = false
            this.playCountAndEpi = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.audPlayLogs = false
            this.epiPlayLogs = false
        },
        playEpisodeTotal() {
            this.playCountTotal = false
            this.playEpisodeTot = !this.playEpisodeTot
            this.playEpi = false
            this.totCountWeb = false
            this.totCountAndroid = false
            this.playCountWebEpi = false
            this.playCountAndEpi = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.audPlayLogs = false
            this.epiPlayLogs = false
        },
        playEpisode() {
            this.playEpi = !this.playEpi
            this.totCountWeb = false
            this.totCountAndroid = false
            this.playCountWebEpi = false
            this.playCountAndEpi = false
            this.playCountTotal = false
            this.playEpisodeTot = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.audPlayLogs = false
            this.epiPlayLogs = false
        },
        totalCountWeb() {
            this.totCountWeb = !this.totCountWeb
            this.totCountAndroid = false
            this.playCountWebEpi = false
            this.playCountAndEpi = false
            this.playCountTotal = false
            this.playEpisodeTot = false
            this.playEpi = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.audPlayLogs = false
            this.epiPlayLogs = false
        },
        totalFromAndroid() {
            this.totCountAndroid = !this.totCountAndroid
            this.playCountWebEpi = false
            this.playCountAndEpi = false
            this.playCountTotal = false
            this.playEpisodeTot = false
            this.playEpi = false
            this.totCountWeb = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.audPlayLogs = false
            this.epiPlayLogs = false
        },
        totalFromWebEpi() {
            this.playCountWebEpi = !this.playCountWebEpi
            this.playCountAndEpi = false
            this.playCountTotal = false
            this.playEpisodeTot = false
            this.playEpi = false
            this.totCountWeb = false
            this.totCountAndroid = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.audPlayLogs = false
            this.epiPlayLogs = false
        },
        totalFromAndroidEpi() {
            this.playCountAndEpi = !this.playCountAndEpi
            this.playCountTotal = false
            this.playEpisodeTot = false
            this.playEpi = false
            this.totCountWeb = false
            this.totCountAndroid = false
            this.playCountWebEpi = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.audPlayLogs = false
            this.epiPlayLogs = false
        },
        totalAudLogs() {
            this.audPlayLogs = !this.audPlayLogs
            this.playCountTotal = false
            this.playEpisodeTot = false
            this.playEpi = false
            this.totCountWeb = false
            this.totCountAndroid = false
            this.playCountWebEpi = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.playCountAndEpi = false
            this.epiPlayLogs = false
        },
        totalEpiLogs() {
            this.epiPlayLogs = !this.epiPlayLogs
            this.playCountTotal = false
            this.playEpisodeTot = false
            this.playEpi = false
            this.totCountWeb = false
            this.totCountAndroid = false
            this.playCountWebEpi = false
            this.loadFlag = false
            this.audioBookPlay = false
            this.audPlayLogs = false
            this.playCountAndEpi = false
        }
    }
}
</script>

<style scoped>
/* .btn {
    background: black;
} */

div .btn-group button {
    background: black;
}
</style>